import { render, staticRenderFns } from "./PersonListItem.vue?vue&type=template&id=c99b7388&scoped=true"
import script from "./PersonListItem.vue?vue&type=script&lang=ts"
export * from "./PersonListItem.vue?vue&type=script&lang=ts"
import style0 from "./PersonListItem.vue?vue&type=style&index=0&id=c99b7388&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c99b7388",
  null
  
)

export default component.exports